<template>
  <div>
    <div class="filter-pannel">
      <ul class="cates">
        <li class="cate-item" :class="{'active':activeCategory==0}" @click="setActive(0)">全部</li>
        <li v-for="examType in examTypes" :key="examType.id" :id="'cate'+examType.id" class="cate-item"
          :class="{'active':activeCategory==examType.id}" @click="setActive(examType.id)">
          {{examType.name}}
        </li>
      </ul>
      <div class="filter-btn-wrap" style="padding:0 10px">
        <van-icon name="arrow-down" size="16" color="#689597" style="margin: 16px 0;" @click="switchFilterVisible()" />
      </div>
    </div>
    <div class="goods-wrapper">
      <div class="package-group" v-if="packageList.length>0">
        <div v-for="(pkg,index) in packageList" :key="pkg.xh">
          <router-link :to="{path:'/packageDetail',query:{id:pkg.xh}}" class="package-row">
            <div class="package-img" :class="pkg.sex_limit==2?'package-img--female':''"></div>
            <div class="package-info">
              <div class="package-name">{{pkg.name}}</div>
              <div class="package-desc">{{pkg.remark}}</div>
              <div class="package-footer">
                <div class="package-price">￥{{pkg.sale_price}}</div>
                <div class="package-order-count">{{pkg.appoint_count}}人已预约</div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="package-group" v-else>
        <div class="package-empty-wrapper">
          <van-empty description="未找到相关体检套餐" />
        </div>
      </div>
      <div class="bottom-info" v-if="packageList && packageList.length>0">已全部加载完成</div>
    </div>
    <footerTabbar :activeIndex="1" />

    <!-- 过滤条件弹出窗口 -->
    <van-popup v-model="showFilter" position="top" class="filter-popup" round>
      <div class="filter-wrapper">
        <h4>适宜人群</h4>
        <div class="fit-groups">
          <span :class="activeGender=='0'?'active-sort-item':''" @click="activeGender='0'">不限</span>
          <span :class="activeGender=='1'?'active-sort-item':''" @click="activeGender='1'">男性</span>
          <span :class="activeGender=='2'?'active-sort-item':''" @click="activeGender='2'">女性</span>
        </div>
        <h4>排序方式</h4>
        <div class="sortby-items">
          <span :class="activeSort=='default'?'active-sort-item':''" @click="activeSort='default'">综合</span>
          <span :class="activeSort=='sale'?'active-sort-item':''" @click="activeSort='sale'">销量</span>
          <span :class="activeSort=='price-desc'?'active-sort-item':''" @click="activeSort='price-desc'">价格 ▼</span>
          <span :class="activeSort=='price'?'active-sort-item':''" @click="activeSort='price'">价格 ▲</span>
        </div>
      </div>
      <div class="filter-bottom">
        <van-button plain @click style="width:50%" @click="filterReset">重置</van-button>
        <van-button type="info" @click style="width:50%" @click="filterAndSort">确定</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showCategories" position="top" class="" :style="{ height: '100%',zIndex:'3333' }"
      :closeable="false">
      <h3 class="exam-type-title">请选择体检类型</h3>
      <ul class="exam-type-list">
        <li v-for="(examType,index) in examTypes" class="exam-type-item" @click="setActive(examType.id)">
          <img :src="examType.img_url|imgPath" class="exam-type-img" />
          <div class="exam-type-name">
            <span>{{examType.name}}</span></div>
        </li>
      </ul>
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .filter-pannel {
    z-index: 2222;
    display: flex;
    position: sticky;
    top: 0px;
    background: #ffffff;
    box-shadow: 0 1px 4px #00152914;

    .cates {
      padding: 0 12px;
      flex: 1;
      overflow-x: auto;
      white-space: nowrap;

      .cate-item {
        list-style: none;
        display: inline-block; //使li对象显示为一行
        margin: 10px 0;
        padding: 4px 12px;
        border: 1px solid #eeeeee;
        border-radius: 16px;
        font-size: 13px;
        margin-right: 10px;
        cursor: pointer;
      }

      .active {
        background: var(--color-gradient);
        color: #fff;
        border: none;
      }
    }

    .filter-btn-wrap {
      box-shadow: -4px 0px 4px #00152914;
    }
  }

  .filter-popup {
    background: #ffffff;
    z-index: 100;
    border-radius: 0 0 10px 10px;
    top: 48px !important;

    .filter-wrapper {
      padding: 0 16px;

      .fit-groups {
        margin-bottom: 24px;
      }

      .sortby-items {
        margin-bottom: 24px;
      }

      .active-sort-item {
        background: var(--color-main);
        color: #fff;
        border: 1px solid var(--color-main);
      }

      h4 {
        font-size: 14px;
        font-weight: 500;
        line-height: 40px;
        margin-top: 8px;
      }

      div {
        display: flex;
        flex-wrap: wrap;
      }

      span {
        flex: 1;
        font-size: 12px;
        padding: 4px 8px;
        border-radius: 4px;
        margin-top: 8px;
        margin-right: 8px;
        background: #f3f3f3;
        border: 1px solid #eeeeee;
        text-align: center;
      }
    }

    .filter-bottom {
      margin-top: 32px;
    }

    .van-button {
      border-radius: 0px;
    }
  }

  .exam-type-title {
    font-size: 18px;
    padding: 32px 0;
    text-align: center;
  }

  .exam-type-list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;

    .exam-type-item {
      width: 33.33%;
      text-align: center;
      padding: 16px 0;

      .exam-type-img {
        height: 90px;
        width: 90px;
      }

      .exam-type-name {
        margin-top: 8px;
        font-size: 13px;
        text-align: center;

        span {
          // border: 1px solid #d2d2d2;
          border-radius: 10px;
          padding: 2px 8px;
        }
      }
    }
  }

  .goods-wrapper {
    background: #f3f3f3;

    .bottom-info {
      padding-bottom: 24px;
      text-align: center;
      font-size: 13px;
    }
  }

  .package-group {
    padding: 16px 10px;
  }

  .package-row {
    display: flex;
    background: #ffffff;
    padding: 20px 12px;
    margin-bottom: 16px;
    border-radius: 8px;

    .package-img {
      margin-right: 16px;
      width: 100px;
      height: 100px;
      border-radius: 8px;
      background: #eeeeee;
      background-image: url('../../assets/images/healthexam.png');
      background-size: cover;
      background-position: center;
    }

    .package-img--male {
      background-image: url('../../assets/images/healthexam.png');
    }

    .package-img--female {
      background-image: url('../../assets/images/package-female.png');
    }

    .package-info {
      flex: 1;

      .package-name {
        font-size: 16px;
        margin-bottom: 12px;
      }

      .package-desc {
        height: 36px;
        font-size: 13px;
        color: rgba(0, 0, 0, 0.45);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .package-footer {
        margin-top: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        justify-items: center;

        .package-order-count {
          font-size: 13px;
          color: #999999;
        }

        .package-price {
          flex: 1;
          color: #fe8658;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
        }

        .package-price:first-letter {
          font-size: 12px;
        }
      }
    }
  }
</style>

<script>
  import footerTabbar from "../components/footerTabbar.vue";
  import * as api_package from "@/api/package";
  export default {
    components: {
      footerTabbar
    },
    data() {
      return {
        active: 1,
        showFilter: false,
        activeCategory: 0,
        activeGender: '0',
        activeSort: 'default',
        examTypes: [],
        recommandPackages: [],
        allPackages: [], //所有体检套餐
        packageList: [], //当前界面显示的套餐列表
        showCategories: false, //是否显示体检类型列表
      };
    },
    mounted() {
      let hospId = this.$route.query.hospid;
      if (!hospId) {
        hospId = localStorage.getItem("hospid");
      }
      api_package.getExamTypes(hospId).then(res => {
        this.examTypes = res.data;
        if (this.examTypes.length > 1) {
          this.showCategories = true;
        }
      })
      api_package.getPackages(hospId).then(resp => {
        this.allPackages = resp.data;
        this.packageList = resp.data;
      })

    },
    methods: {
      switchFilterVisible() {
        this.showFilter = !this.showFilter;
      },
      setActive(code) {
        this.activeCategory = code;
        this.filterPackages(code);
        this.showCategories = false;
        let dom = document.getElementById('cate' + code);
        if (dom) {
          dom.scrollIntoView();
        }
      },
      filterPackages(examType, gender, marital, sort) {
        let packages = [];
        if (examType == 0) {
          packages = this.allPackages;
        } else {
          packages = this.allPackages.filter(p => p.exam_type_id == examType);
        }
        if (gender !== '0') {
          if (gender == '1')
            packages = packages.filter(p => p.sex_limit == 1);
          else if (gender == '2')
            packages = packages.filter(p => p.sex_limit == 2);
        }

        if (sort == undefined || sort == null || sort == 'default') {
          packages = packages.sort((a, b) => {
            if (a.sort == b.sort) {
              return b.appoint_count - a.appoint_count
            } else {
              return a.sort - b.sort
            }
          });
        } else if (sort == "sale") {
          packages = packages.sort((a, b) => {
            if (a.appoint_count == b.appoint_count) {
              return a.sort - a.sort
            } else {
              return b.appoint_count - a.appoint_count
            }
          });
        } else if (sort == "price") {
          packages = packages.sort((a, b) => {
            if (a.price == b.price) {
              return b.appoint_count - a.appoint_count
            } else {
              return a.price - b.price
            }
          });
        } else if (sort = "price-desc") {
          packages = packages.sort((a, b) => {
            if (a.price == b.price) {
              return b.appoint_count - a.appoint_count
            } else {
              return b.price - a.price
            }
          })
        }
        this.packageList = packages;
      },
      filterAndSort() {
        this.filterPackages(this.activeCategory, this.activeGender, null, this.activeSort);
        this.showFilter = false;
        window.scrollTo(0, 0);
      },
      filterReset() {
        this.activeGender = '0';
        this.activeSort = 'default';
        this.filterPackages(this.activeCategory, this.activeGender, null, this.activeSort);
        this.showFilter = false;
        window.scrollTo(0, 0);
      },
    }
  };
</script>